module.exports = __webpack_public_path__ + "img/RobertCastro_140x140_rund.5fc772ec.jpg";